import siteTab from '@/components/tab'
import { mapGetters } from 'vuex'
export default {
  components: {
    siteTab
  },
  data() {
    return {
      menus: [
        {
          name: 'Basic Information',
          href: '/system/publisher/basic-information',
          code: 'SYSTEM.PUBLISH.BASIC_INFORMATION'
        },
        {
          name: 'News',
          href: '/system/publisher/banners',
          code: 'SYSTEM.PUBLISH.BANNER'
        },
        {
          name: 'Publisher Policy',
          href: '/system/publisher/publisher-policy',
          code: 'SYSTEM.PUBLISH.POLICY'
        },
        // {
        //   name: 'Key Relationship ',
        //   href: '/system/publisher/key-relationship',
        //   code: 'SYSTEM.PUBLISH.COLLABORATION'
        // },
        // {
        //   name: 'Database',
        //   href: '/system/publisher/database',
        //   code: 'SYSTEM.PUBLISH.DATABASE'
        // },
        {
          name: 'Management Team',
          href: '/system/publisher/management-team',
          code: 'SYSTEM.PUBLISH.TEAM'
        },
        {
          name: 'Info Page',
          href: '/system/publisher/info',
          code: 'SYSTEM.PUBLISH.INFO_PAGE'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    user: {
      handler() {
        this.redict()
      },
      immediate: true
    },
    $route() {
      this.redict()
    }
  },
  methods: {
    redict() {
      if (this.$route.path !== '/system/publisher') {
        return
      }
      this.menus.some(item => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.$router.replace(item.href)
          return true
        }
      })
    }
  }
}
